import formMainHubConfigs from './formMainHubConfigs';
import formConfigInfo from './formConfigInfo';

export default {
  title: 'White Label Pro Config Rules',
  attributeName: 'mhConfigs',
  getURL: 'mainHubs/mainHubId/mainHubConfigs/id/data',
  createURL: 'mainHubs/mainHubId/mainHubConfigs/id/data',
  updateURL: 'mainHubs/mainHubId/mainHubConfigs/id/data',
  removeURL: 'mainHubs/mainHubId/mainHubConfigs/id/data',
  autoUpdate: false,
  idAttribute: 'id',
  idUpdate:true,
  noUpdateWithId: true,
  sessionParams: ['mainHubId'],
  formConfig: [formConfigInfo, formMainHubConfigs],
  noArea: true,
  goBack: false,
  formGroupExpands: true,
};
